__turbopack_context__.v({
  "root": "Barometer-module___qX2Iq__root",
});
